import { Component, AfterViewInit, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

declare var amp;

@Component({
  selector: 'app-bishakha-dutta',
  templateUrl: './bishakha-dutta.component.html',
  styleUrls: ['./bishakha-dutta.component.scss']
})
export class BishakhaDuttaComponent implements AfterViewInit, OnInit, OnDestroy {
  windowsWidth;
  facebookUrl = '';
  buttonShare = false;
  myPlayer;

  constructor() { }

  ngOnInit() {
    this.windowsWidth = window.innerWidth;
    this.goBackToTop();
    this.facebookUrl = window.location.href;
  }

  ngAfterViewInit() {
    const myOptions = {
      nativeControlsForTouch: false,
      logo: { 'enabled': false },
      controls: true,
      autoplay: false,
    };

    this.myPlayer = amp('azuremediaplayerDutta', myOptions);
    this.myPlayer.src([
      {
        'src': 'https://m101-inct.streaming.media.azure.net/415c2d23-6640-43e7-a7d3-2cbdf6d484e3/Verve_Magazine.ism/manifest',
        'type': 'application/vnd.ms-sstr+xml'
      }
    ]);
    if (document.getElementsByClassName('vjs-big-play-button').length) {
      document.getElementsByClassName('vjs-big-play-button')[0].addEventListener('click', this.videoClick.bind(this));
      document.getElementsByClassName('vjs-big-play-button')[0].addEventListener('touchstart', this.videoClick.bind(this));
    }
  }

  ngOnDestroy() {
    this.myPlayer.dispose();
  }

  videoClick() {
    if (this.windowsWidth > 1023) {
      if (document.getElementsByClassName('vjs-fullscreen-control')[0]) {
        (document.getElementsByClassName('vjs-fullscreen-control')[0] as HTMLElement).click();
      }
    }
    if (document.getElementsByClassName('video-cover')[0]) {
      (document.getElementsByClassName('video-cover')[0] as HTMLElement).remove();
    }
    if (document.getElementsByClassName('sound-icon')[0]) {
      (document.getElementsByClassName('sound-icon')[0] as HTMLElement).remove();
    }
  }

  gotoTop() {
    document.getElementById('parentWrap').scrollTo({ 'top': 0, behavior: 'smooth' });
  }

  goBackToTop() {
    document.getElementsByTagName('body')[0].scroll({
      top: 0,
      behavior: 'smooth'
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowsWidth = window.innerWidth;
  }
  shareButton() {
    this.buttonShare = !this.buttonShare;
    if (this.buttonShare === true) {
      document.getElementById('sharePopup').style.display = 'flex';
    } else {
      document.getElementById('sharePopup').style.display = 'none';
    }
  }

}
